import React, { useEffect, useState } from "react";
import axios from "../api/axios";

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    products: 0,
    categories: 0,
    orders: 0,
    users: 0,
  });

  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // Fetch stats

    // Fetch users
    const fetchUsers = async () => {
      try {
        const res = await axios.get("/users");
        setUsers(res.data);
        console.log("✅ Fetched users:", res.data);
      } catch (err) {
        console.error("❌ Failed to fetch users:", err);
      }
    };

    const fetchOrders = async () => {
      try {
        const res = await axios.get("/admin/orders");
        setOrders(res.data);
      } catch (err) {
        console.error("❌ Failed to fetch orders:", err);
      }
    };

    const fetchProducts = async () => {
      try {
        const res = await axios.get("/products");
        setProducts(res.data);
      } catch (err) {
        console.error("❌ Failed to fetch orders:", err);
      }
    };
    const fetchCategories = async () => {
      try {
        const res = await axios.get("/categories");
        setCategories(res.data);
      } catch (err) {
        console.error("❌ Failed to fetch categories:", err);
      }
    };

    // Fetch orders
    fetchUsers();
    fetchOrders();
    fetchProducts();
    fetchCategories();
  }, []);

  return (
    <div className="container py-4">
      <h2 className="mb-4 fw-bold">📊 Admin Dashboard</h2>

      {/* Stats cards */}
      <div className="row g-4 mb-5">
        <div className="col-md-3">
          <div className="card text-white bg-primary h-100 shadow">
            <div className="card-body">
              <h5 className="card-title">🛍️ Products</h5>
              <p className="card-text fs-4">{products.length}</p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-success h-100 shadow">
            <div className="card-body">
              <h5 className="card-title">📂 Categories</h5>
              <p className="card-text fs-4">{categories.filter(c => c.parent_id === null).length}</p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-dark bg-warning h-100 shadow">
            <div className="card-body">
              <h5 className="card-title">📦 Orders</h5>
              <p className="card-text fs-4">{orders.length}</p>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-dark h-100 shadow">
            <div className="card-body">
              <h5 className="card-title">👤 Users</h5>
              <p className="card-text fs-4">{users.length}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Users Table */}
      <h4 className="mb-3">👥 Latest Users</h4>
      <div className="table-responsive mb-5">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.slice(0, 5).map((u) => (
              <tr key={u.id}>
                <td>{u.id}</td>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td>{new Date(u.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Orders Table */}
      <h4 className="mb-3">📦 Latest Orders</h4>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>#Order ID</th>
              <th>Customer</th>
              <th>Total</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.slice(0, 5).map((o) => (
              <tr key={o.id}>
                <td>{o.id}</td>
                <td>{o.full_name || o.user?.name}</td>
                <td>₹{o.total}</td>
                <td>
                  <span
                    className={`badge ${
                      o.status === "completed"
                        ? "bg-success"
                        : o.status === "pending"
                        ? "bg-warning"
                        : "bg-secondary"
                    }`}
                  >
                    {o.status}
                  </span>
                </td>
                <td>{new Date(o.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
